import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import { BPNS_GUIDE_PDF_URL } from '../../constants/sites.constant';

type BpnsHelperLinkProps = {
  className?: string;
};

const BpnsHelperLink = ({ className }: BpnsHelperLinkProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <a
      href={BPNS_GUIDE_PDF_URL}
      target='_blank'
      rel='noopener noreferrer'
      className={classNames('text-primary underline text-sm w-fit', className)}
    >
      {t('global.bpnsHelperLink')}
    </a>
  );
};

export default BpnsHelperLink;
